import { render, staticRenderFns } from "./WidgetsCustomSkeleton.vue?vue&type=template&id=0e916b87&"
import script from "./WidgetsCustomSkeleton.vue?vue&type=script&lang=js&"
export * from "./WidgetsCustomSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports